export default __webpack_public_path__ + "static/media/LogOut.acfb260e.svg";